"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        id: "0",
        name: "NOT APPLICABLE"
    },
    {
        id: "1",
        name: "SELF-CONTAINED"
    },
    {
        id: "2",
        name: "ENGLISH LANGUAGE ARTS"
    },
    {
        id: "3",
        name: "MATHEMATICS"
    },
    {
        id: "4",
        name: "SCIENCE"
    },
    {
        id: "5",
        name: "SOCIAL STUDIES"
    },
    {
        id: "6",
        name: "PHYSICAL ED. & HEALTH"
    },
    {
        id: "7",
        name: "FOREIGN LANGUAGE"
    },
    {
        id: "8",
        name: "FINE ARTS"
    },
    {
        id: "9",
        name: "TECHNOLOGY APPLICATIONS"
    },
    {
        id: "11",
        name: "CAREER & TECHNOLOGY EDUCATION"
    },
    {
        id: "12",
        name: "SPECIAL EDUCATION"
    },
    {
        id: "99",
        name: "OTHER"
    }
];
//# sourceMappingURL=subjectAreas.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/subjects_data/subjectAreas.js
// module id = 205
// module chunks = 22